import type { FaireProductEntity } from "../../entity_types/product";

export const p_zpnr33t57v: FaireProductEntity = {
  token: "p_zpnr33t57v",
  type: "product",
  name: "Little Book of Fika by Lynda  Balslev",
  brandToken: "b_7a909d43",
  brandName: "Simon & Schuster",
  imageUrl: "https://cdn.faire.com/fastly/86244f0ea8b25daf54a8ca453408315f7e99dad9c03b6d0df289a938d7d1115e.jpeg",
  galleryImageUrls: [],
  priceDollars: 5,
  description: "[AMP]\r\n\r\nA little book on the Swedish tradition of fika—the twice-daily coffee break—including facts, quotes, tips, and 20 sweet and savory recipes. \r\n\r\nWhile the Danish concept of hygge as caught on around the globe, so has lagom—its Swedish counterpart. An essential part of the lagom lifestyle, fika is the simple art of taking a break—sometimes twice a day—to enjoy a warm beverage and sweet treat with friends. This delightful gift book offers an introduction to the tradition along with recipes to help you establish your own fika practice.",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:38.171Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
